/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import TopNav from "../../components/top-navigation";
import SiderBar from "../../components/sider";
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import firebase from "firebase";
import { auth as firebaseAppAuthUser } from "../../components/firestore_user";
import { db } from "../../components/firestore";
import Buttons from "./buttons";
import { Alert, Row, Col, Layout, Typography } from "antd";
import { TextLoop } from "react-text-loop-next";
import Common from "./common";
import IsMobileView from "../../components/utils/mobileView";
import { Link, useLocation } from "react-router-dom";
import { SHORTED_LOGO_URL } from "../../constants/branding";
import { useLeadCapture } from "../../components/lead-capture";
import { onDistributionAuthResult } from "../../components/utils/syncDistributionProfile";
const isFacebookApp = () => {
  try {
    var ua = navigator.userAgent || navigator.vendor || window.opera;
    return (
      ua.indexOf("FBAN") > -1 ||
      ua.indexOf("FBAV") > -1 ||
      ua.indexOf("Instagram") > -1
    );
  } catch {
    return false;
  }
};

const uiConfig = {
  // Popup signin flow rather than redirect flow.
  signInFlow: !isFacebookApp() ? "popup" : "redirect",
  signInOptions: [
    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    firebase.auth.EmailAuthProvider.PROVIDER_ID,
  ],
  signInSuccessUrl: false,
  callbacks: {
    signInSuccessWithAuthResult(authResult) {
      onDistributionAuthResult(authResult);
      return false;
    },
  },
};

const { Content } = Layout;
const { Title, Text } = Typography;

const LANDING_MAX = 1120;

const Wrapper = ({ auth_user, children }) => {
  const openLeadCapture = useLeadCapture();
  const location = useLocation();
  const [checklist, updateChecklist] = useState([]);
  const canAccessApp = Boolean(auth_user?.user);
  const siderSelectedKey =
    location.pathname === "/payouts"
      ? ["2"]
      : location.pathname === "/"
      ? ["1"]
      : [];
  const movies_load = async () => {
    try {
      const docChecklist = await db
        .collection("pages")
        .doc("distribution")
        .get();
      const raw = docChecklist.data();
      if (!raw) return;
      const data = { ...raw };
      ["layout", "featured", "testimonials", "trending"].forEach((key) => {
        const v = data[key];
        if (typeof v === "string") {
          try {
            data[key] = JSON.parse(v);
          } catch {
            /* keep string */
          }
        }
      });
      updateChecklist(data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    movies_load();
  }, []);
  const isMobileView = IsMobileView();
  return (
    <React.Fragment>
      <>
        {canAccessApp ? (
          <Layout className="vc-dashboard" style={{ minHeight: "100vh" }}>
            <SiderBar selectedKey={siderSelectedKey} openKey={[]} />
            <Layout>
              <TopNav auth_user={auth_user} dashboard />
              {children}
            </Layout>
          </Layout>
        ) : (
          <Layout
            className="vc-dashboard vc-landing"
            style={{
              minHeight: "100vh",
              display: "flex",
              flexDirection: "column",
              background: "var(--vc-bg)",
            }}
          >
            <div
              style={{
                borderBottom: "1px solid var(--vc-border)",
                background: "var(--vc-bg-panel)",
              }}
            >
              <div
                style={{
                  maxWidth: LANDING_MAX,
                  margin: "0 auto",
                  padding: "0 16px 0 24px",
                  minHeight: isMobileView ? 52 : 56,
                  display: "grid",
                  gridTemplateColumns: "1fr auto 1fr",
                  alignItems: "center",
                  columnGap: 8,
                }}
              >
                <span aria-hidden style={{ minWidth: 0 }} />
                <Link
                  to="/"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    lineHeight: 0,
                  }}
                  aria-label="Shorted home"
                >
                  <img
                    src={SHORTED_LOGO_URL}
                    alt=""
                    width={140}
                    height={54}
                    style={{
                      width: isMobileView ? 108 : 132,
                      height: "auto",
                      maxHeight: isMobileView ? 36 : 42,
                      objectFit: "contain",
                    }}
                  />
                </Link>
                <div
                  style={{
                    justifySelf: "end",
                    minWidth: 0,
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <TopNav auth_user={auth_user} dashboard />
                </div>
              </div>
            </div>
            <Content style={{ flex: 1 }}>
              <div className="vc-landing-hero">
                <Row
                  gutter={[0, 24]}
                  style={{
                    maxWidth: LANDING_MAX,
                    margin: "0 auto",
                    padding: isMobileView ? "40px 24px 48px" : "56px 24px 64px",
                    textAlign: "center",
                  }}
                >
                  <Col span={24}>
                    <Title
                      level={1}
                      style={{
                        fontSize: isMobileView ? 32 : 42,
                        fontWeight: 700,
                        marginBottom: 16,
                        letterSpacing: "-0.03em",
                        lineHeight: 1.15,
                      }}
                    >
                      Distribute Your Films Like a Pro
                    </Title>
                    <Text
                      type="secondary"
                      style={{
                        fontSize: isMobileView ? 15 : 16,
                        display: "block",
                        maxWidth: 520,
                        margin: "0 auto 24px",
                        lineHeight: 1.6,
                      }}
                    >
                      Unleash Your Full Potential with Our Distribution +
                      Marketing Suite
                    </Text>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <Buttons />
                    </div>
                  </Col>
                </Row>
              </div>
              <div
                style={{
                  maxWidth: 560,
                  margin: "0 auto",
                  width: "100%",
                  padding: "0 24px 48px",
                }}
              >
                {checklist.notifications && (
                  <Alert
                    banner
                    message={
                      <TextLoop mask noWrap={false}>
                        {checklist.notifications.map((item, index) => (
                          <div key={index}>{item}</div>
                        ))}
                      </TextLoop>
                    }
                    type="info"
                    style={{
                      marginBottom: 16,
                      minHeight: window.innerWidth < 530 ? 76 : 40,
                    }}
                  />
                )}
                <div
                  id="login"
                  className="vc-panel vc-landing-signin"
                  style={{ padding: isMobileView ? 24 : 32 }}
                >
                  <Title level={4} style={{ marginBottom: 8 }}>
                    Sign in to your SHORTED account
                  </Title>
                  <Text
                    type="secondary"
                    style={{ display: "block", marginBottom: 24 }}
                  >
                    Use the same account you used when you joined the queue on
                    SHORTED. Need another film reviewed?{" "}
                    <a
                      role="button"
                      href="#lead"
                      onClick={(e) => {
                        e.preventDefault();
                        openLeadCapture();
                      }}
                      title="Request invite-only distribution access"
                    >
                      Request Access
                    </a>
                    .
                  </Text>
                  <StyledFirebaseAuth
                    uiConfig={uiConfig}
                    firebaseAuth={firebaseAppAuthUser}
                    uiCallback={(ui) => ui.reset()}
                  />
                </div>
              </div>
              <Common checklist={checklist} auth_user={auth_user} />
            </Content>
          </Layout>
        )}
        <Layout className="vc-footer">
          <Col
            className="gutter-row"
            md={{ span: 24 }}
            style={{
              display: "flex",
              flexDirection: "column",
              maxWidth: LANDING_MAX,
              margin: "0 auto",
              width: "100%",
              padding: "24px",
            }}
          >
            <p>
              {auth_user && auth_user.user && (
                <>
                  {" "}
                  For support, email us at <b>support@shortedfilms.com </b>{" "}
                  <br />
                  <br />
                </>
              )}
              © SHORTED 2026. All Rights Reserved.
              <br />
              <a href="https://shorted.in/terms-conditions/">
                Terms and Conditions
              </a>{" "}
              • <a href="https://shorted.in/privacy-policy/">Privacy Policy</a>
            </p>
          </Col>
        </Layout>
      </>
    </React.Fragment>
  );
};

export default Wrapper;
